// extracted by mini-css-extract-plugin
export default {"container":"style_container__i-E9j","label":"style_label__492Cd"};